module.exports = __webpack_public_path__ + "static/media/og06.8cc8a0e0.webp";